import type { ContractType } from 'src/apis/contract-management/types';

export const contractTypeLabels: Record<ContractType, string> = {
  FMCT: 'Frame Contract',
  DECT: 'Derived Contract',
  LECT: 'Legacy Contract',
};
